module.exports = __webpack_public_path__ + "img/home-banner.65f4cf48.png";